import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { oktaAuthHandler } from '@choreograph/authjs'

export const basePermissionManagerApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.SERVICE_AUTHORISATION_URL,
    prepareHeaders: (headers) => {
      const token = oktaAuthHandler.getAccessToken()
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
    paramsSerializer: (params: Record<string, unknown>) => {
      const searchParams = new URLSearchParams()

      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => searchParams.append(key, item))
        } else if (value !== null && value !== undefined && value !== '') {
          /* istanbul ignore next */
          if (
            typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean'
          ) {
            searchParams.append(key, String(value))
          } else {
            searchParams.append(key, JSON.stringify(value))
          }
        }
      })

      return searchParams.toString()
    },
  }),
  reducerPath: 'permissionManagerApi',
  tagTypes: [
    'User',
    'Relations',
    'Relationship',
    'Namespace',
    'ResourceType',
    'permission',
  ],
  endpoints: () => ({})
})
